import { PanelTop } from 'lucide-react';
import React from 'react';
import Spacing from '../Spacing';
import { Link } from 'react-router-dom';

export default function WebsiteSeo() {
  return (
    <>
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24">
          <i
            className="docpro_white_color"
            style={{ backgroundColor: '#8DA4EF' }}
          >
            <PanelTop width={20} height={20} />
          </i>
          Website & SEO
        </h2>
      </div>
      <Spacing lg="20" sm="20" />
      <div className="docpro_grid docpro_grid_col_2 docpro_grid_gap_10">
        <div className="docpro_grid_item">
          <div className="docpro_card docpro_card_3">
            <h2 className="docpro_fs_35 docpro_mb_0">
              A professional website <br />
              for your clinic.
            </h2>
            <Spacing lg="12" sm="12" />
            <h3 className="docpro_fs_20 docpro_fw_500 docpro_mb_0">
              We create & manage the website for you. <br />
              It's like having a tech team — in your pocket.
            </h3>
            <Spacing lg="40" sm="40" />
            <Link to="/website-seo" className="docpro_card_thumb">
              <img
                src="/images/website_1.jpeg"
                alt=""
                style={{ boxShadow: '0 4px 40px rgba(29, 48, 96, 0.25)' }}
              />
              <span className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg">
                Visite Now
              </span>
            </Link>
          </div>
        </div>
        <div className="docpro_grid_item">
          <div className="docpro_card docpro_card_3">
            <h2 className="docpro_fs_35 docpro_mb_0">
              SEO helps you drive <br />
              more patients to your clinic
            </h2>
            <Spacing lg="12" sm="12" />
            <h3 className="docpro_fs_20 docpro_fw_500 docpro_mb_0">
              Rank higher when someone searches for <br />
              “primary care near me”, or similar terms.
            </h3>
            <Spacing lg="40" sm="40" />
            <Link to="/website-seo" className="docpro_card_thumb">
              <img src="/images/website_2.png" alt="" />
              <span className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg">
                Visite Now
              </span>
            </Link>
          </div>
        </div>
      </div>
      <Spacing lg="20" sm="20" />
    </>
  );
}
